let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4f7k3")).then(() => parcelRequire('8h3N4'));